import * as React from "react"
import { Link } from "gatsby"
import Logo from "../images/logo.inline.svg"
import Instagram from "../images/instagram.inline.svg"
import Facebook from "../images/facebook.inline.svg"

const HomeNavBar = ({ aboutRef, workRef, reviewRef, aboutMarathonRef }) => {
  const [show, setShow] = React.useState(false)

  return (
    <div
      data-collapse="medium"
      id="navigation"
      role="banner"
      className="navbar w-nav"
    >
      <div className="navigation-container">
        <div className="navigation-left">
          <Link
            to="/"
            aria-current="page"
            className="brand w-nav-brand"
            aria-label="home"
          >
            <Logo style={{ width: 200 }} />
          </Link>
        </div>
        <nav role="navigation" className="nav-menu w-nav-menu">
          <button
            className="nav-link w-nav-link"
            onClick={() => {
              aboutMarathonRef.current.scrollIntoView({ behavior: "smooth" })
            }}
          >
            О марафоне
          </button>
          <button
            className="nav-link w-nav-link"
            onClick={() => {
              workRef.current.scrollIntoView({ behavior: "smooth" })
            }}
          >
            Тарифы
          </button>
          <button
            className="nav-link w-nav-link"
            onClick={() => {
              aboutRef.current.scrollIntoView({ behavior: "smooth" })
            }}
          >
            Обо мне
          </button>
          <button
            className="nav-link w-nav-link"
            onClick={() => {
              reviewRef.current.scrollIntoView({ behavior: "smooth" })
            }}
          >
            Отзывы
          </button>
          <button
            className="button button-form w-button"
            onClick={() => {
              workRef.current.scrollIntoView({ behavior: "smooth" })
            }}
          >
            Записаться
          </button>
        </nav>
        <div className="navigation-right">
          <button
            className={`menu-button w-nav-button${show ? " w--open" : ""}`}
            aria-label="menu"
            tabIndex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded={!!show}
            onClick={() => setShow(!show)}
          >
            <span className="line-menu line-top" />
            <span className="line-menu line-bottom" />
          </button>
          <div className="social-link-wrapper">
            <a
              href="https://www.instagram.com/starikova.dar/"
              className="social-link w-inline-block"
              target="_blank"
              rel="noreferrer"
            >
              <Instagram className="social-icon" />
            </a>
            <a
              href="https://www.facebook.com/dasha.starikova.7"
              className="social-link w-inline-block"
              target="_blank"
              rel="noreferrer"
            >
              <Facebook className="social-icon" />
            </a>
          </div>
        </div>
      </div>
      <div
        className="w-nav-overlay"
        id="w-nav-overlay-0"
        style={{
          display: `${show ? "block" : "none"}`,
        }}
      >
        <nav
          role="navigation"
          className="nav-menu w-nav-menu"
          style={{
            display: `${show ? "flex" : "none"}`,
          }}
        >
          <button
            className="nav-link w-nav-link w--nav-link-open"
            onClick={() => {
              aboutMarathonRef.current.scrollIntoView({ behavior: "smooth" })
            }}
          >
            О марафоне
          </button>
          <button
            className="nav-link w-nav-link w--nav-link-open"
            onClick={() => {
              workRef.current.scrollIntoView({ behavior: "smooth" })
            }}
          >
            Тарифы
          </button>
          <button
            className="nav-link w-nav-link"
            onClick={() => {
              aboutRef.current.scrollIntoView({ behavior: "smooth" })
            }}
          >
            Обо мне
          </button>
          <button
            className="nav-link w-nav-link w--nav-link-open"
            onClick={() => {
              reviewRef.current.scrollIntoView({ behavior: "smooth" })
            }}
          >
            Отзывы
          </button>
          <button
            className="button button-form w-button"
            onClick={() => {
              workRef.current.scrollIntoView({ behavior: "smooth" })
            }}
          >
            Записаться
          </button>
        </nav>
      </div>
    </div>
  )
}

export default HomeNavBar
